import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, first, Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class JwtService {
  public locationData$: State<any>;
  public userLocationData$: State<any>;
  public franchiseData$: State<any>;
  public location$: Observable<any>;
  public franchise$: Observable<any>;
  public userLocation$: Observable<any>;
  public isSignedIn$: BehaviorSubject<any> = new BehaviorSubject(false);
  constructor(private _http: HttpClient, 
    public router: Router,
    private _cookieService: CookieService,) { 
    this.locationData$ = new State([]);
    this.userLocationData$ = new State([]);
    this.franchiseData$ = new State([]);
    this.location$ = select$(this.locationData$, data => data);
    this.franchise$ = select$(this.franchiseData$, data => data);
    this.userLocation$ = select$(this.userLocationData$, data => data);
  }

  validateToken(): Observable<any>{
    const token = localStorage.getItem('token');
    return this._http.get(`${environment.apiUrl}/auth/validate-token/`, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
  }

  onSaveUser(user): Observable<any> {
    return this._http.post(`${environment.apiUrl}/signup`, user);
  }

  onSaveRole(role): Observable<any> {
    return this._http.post(`${environment.apiUrl}/roles`, role);
  }

  onValidateUser(user: HttpResponse<any>): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/auth/login-user`, user, {
      headers: {
        'deviceType': 'web'
      }
    });
  }


  onValidateAccount(user: HttpResponse<any>): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/auth/validate-account`, user);
  }

  onValidateAccountWithLocation(frenchise,sso=false): Observable<any>{
    return this._http.post<any>(`${environment.apiUrl}/auth/validate-location`, {
      usrFranchiseID: frenchise,
      useSSO: sso,
      usrUsername: localStorage.getItem('username')
    },
    {
      headers: {
        'deviceType': 'web'
      }
    });
  }

  onValidateAccountWithPassword(password): Observable<any>{
    return this._http.post<any>(`${environment.apiUrl}/auth/validate-password`, {
      usrPassword: password,
      usrUsername: localStorage.getItem('username'),
      usrFranchiseID: localStorage.getItem('franchise'),
      usrLocationID: localStorage.getItem('locationsUser'),
    }, {
      headers: {
        'deviceType': 'web'
      }
    });
  }

  onSetLocations(locations){
    return this.locationData$.next(locations);
  }

  onSetFrenchises(franchises){
    return this.franchiseData$.next(franchises);
  }

  onSetUserLocations(userLocations){
    return this.userLocationData$.next(userLocations);
  }

  profile(): Observable<any> {
    return this._http.get(`${environment.apiUrl}/auth/user`);
  }

  sendResetPasswordLink(data, usrLocation):Observable<any> {
    return this._http.post(`${environment.apiUrl}/auth/reset-password-request`, data, {
      params:{
        usrLocation
      }
    });
  }

  resetPassword(data) {
    return this._http.post(`${environment.apiUrl}/auth/change-password` , data, {
      headers: {
        deviceType: "web"
      }
    });
  }

  validateResetToken(token: string) {
    return this._http.post(`${environment.apiUrl}/auth/validate-reset-token`, { token });
  }

  refreshToken() {
    return this._http.get(`${environment.apiUrl}/auth/token-refresh`)
  }

  onForgotUser(form){
    return this._http.post(`${environment.apiUrl}/auth/forgot-user`, {
      usrEmail: form.usrEmail,
      usrLocation: form.usrLocation
    });
  }

  onLogOut(){
    return this._http.get(`${environment.apiUrl}/auth/signout`, {
      headers: {
        Authorization: `${localStorage.getItem('token')}`,
        'deviceType': 'web'
      }
    }).pipe(first()).subscribe(() => {
      this._cookieService.delete('access_token');
      var userColumnValue = localStorage.getItem('allColumns');
      localStorage.clear();
      localStorage.setItem('allColumns', userColumnValue);
      // localStorage.removeItem('token');
      // localStorage.removeItem('trakrCountingQbAccessToken');
      // localStorage.removeItem('trakrCountingQbRefreshToken');
      // localStorage.removeItem('location');
      // localStorage.removeItem('sso_token');
      // localStorage.removeItem('sso_franchise');
      // localStorage.removeItem('franchise');
      //this.router.navigate(['login']);
      // Post-logout redirect:
      //   - production (counting.trakrsuite.com) → marketing login page
      //     on www.trakrsuite.com, the canonical entry point for real users
      //   - every other host (counting-preprod / -staging / -local / -qa)
      //     → that subdomain's own /login, so the user lands back on the
      //     environment they were actually working in instead of being
      //     bounced to a different site
      const isProdHost = window.location.hostname === 'counting.trakrsuite.com';
      window.location.href = isProdHost
        ? 'https://www.trakrsuite.com/login'
        : `${window.location.origin}/login`;
    })
  }
  /* Start Multilocations JWT */
  onSaveLocation(location): Observable<any> {
    return this._http.post(`${environment.apiUrl}/locations/add`, location);
  }
  /* Start Multilocations JWT */
}